export const movieLinks = {
  roadInsights: 'https://o2motionportalui.z35.web.core.windows.net/road-insights-v1.mp4',
  mliDemo: 'https://o2motionportalui.z35.web.core.windows.net/mli-demo-v1.mp4',
  jubileeMap: 'https://o2motionportalui.z35.web.core.windows.net/jubilee_map.mp4',
  railInsights: 'https://o2motionportalui.z35.web.core.windows.net/station-insights-v1.mp4',
  rttiDemo: 'https://o2motionportalui.z35.web.core.windows.net/RTTI_full_v2.mp4',
  rtliHexagon: 'https://o2motionportalui.z35.web.core.windows.net/rtli-hexagon.mp4',
};
